package com.havn.app.core.settings

import kotlinx.browser.window

private const val AgencyIdPrefix = "havn.selectedAgencyId."

actual fun loadStoredHavnSelectedAgencyId(userId: String): String? =
    window.localStorage.getItem(AgencyIdPrefix + userId)

actual fun storeHavnSelectedAgencyId(userId: String, agencyId: String?) {
    val key = AgencyIdPrefix + userId
    if (agencyId == null) {
        window.localStorage.removeItem(key)
    } else {
        window.localStorage.setItem(key, agencyId)
    }
}
